import { render, staticRenderFns } from "./PepListaOrderSet.vue?vue&type=template&id=6ed30fb5&"
import script from "./PepListaOrderSet.vue?vue&type=script&lang=js&"
export * from "./PepListaOrderSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports